<template>
  <Card class="cardData">
    <Card class="toolbar--height extraGrey--text text-xs-right pt-3 pr-2">
      <div class="">
        {{ dateFrom }}
        - {{ dateTo }}
      </div>
    </Card>
    <CustomCard tile flat v-for="item in cardData" :key="item.name">
      <v-divider></v-divider>
      <v-layout row wrap pa-1>
        <v-flex md1 pl-3 pt-2>
          <label class="radioBtn--outer" v-show="active == 'compare_graph'">
            <input type="checkbox" :class="`--${simpleString(item.name)}`"
              v-model="checkbox[item.name]" @change="checkboxChangeHandler(item.name, item.id)" />
            <span class="radioBtn--inner"></span>
          </label>
        </v-flex>
        <v-flex md11 pa-2 @click="checkboxChangeHandler(item.name, item.id)">
          <div class="extraGrey--text">{{item.name}}</div>
          <v-layout row wrap>
            <v-flex md6>
              <div class="try--text">{{ $t('Down Time') }} (min)</div>
              <div class="subheading">{{ item['down time'] }}</div>
            </v-flex>
            <v-flex md6 text-xs-right>
              <div class="try--text pt-1">{{ $t('Energy Loss') }} (kWh)</div>
              <div class="subheading">{{ item['energy loss'] }}</div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </CustomCard>
  </Card>
</template>

<script>
import _ from 'lodash'
import {
  mapGetters
} from 'vuex'
import {
  mixin
} from '@/util/mixin/index'
import CustomCard from '../../components/static-info/CustomCard.vue'

export default {
  mixins: [mixin],
  props: {
    active: {
      type: String,
      default: ''
    },
    cardData: {
      type: Array,
      default: function () {
        return []
      }
    },
    dateFrom: {
      type: String,
      default: ''
    },
    dateTo: {
      type: String,
      default: ''
    },
    reset: {
      type: Number
    }
  },
  components: {
    CustomCard
  },
  data() {
    return {
      checkbox: {},
      initialCall: false,
      resetPoint: 0
    }
  },
  computed: {
    ...mapGetters(['getGeneralState']),
    transformedCardData() {
      return this.cardData.map(cd => {
        return {
          name: cd.name,
          id: cd.id
        }
      })
    }
  },
  methods: {
    initialCheckbox() {
      this.initialCall = true
      this.cardData.forEach((cd, index) => {
        if (index === 0) {
          if (!this.checkbox[cd.name]) {
            this.$set(this.checkbox, cd.name, true)
            document.querySelector(`.--${this.simpleString(cd.name)}`).checked = true
          }
          this.$emit('cardSelected', { id: cd.id, componentHasBeenReset: this.resetPoint })
        } else {
          this.$set(this.checkbox, cd.name, false)
          document.querySelector(`.--${this.simpleString(cd.name)}`).checked = false
        }
      })
    },
    checkboxChangeHandler(name, deviceId) {
      Object.keys(this.checkbox).forEach(cb => {
        if (this.checkbox[cb]) {
          this.checkbox[cb] = false
          document.querySelector(`.--${this.simpleString(cb)}`).checked = false
        }
      })
      const checkboxIdentifier = `--${this.simpleString(name)}`
      this.checkbox[name] = !this.checkbox[name]
      document.querySelector(`.${checkboxIdentifier}`).checked = this.checkbox[name]
      this.$emit('cardSelected', { id: deviceId, componentHasBeenReset: this.resetPoint })
    }
  },
  watch: {
    cardData() {
      if (this.active === 'compare_graph') {
        const cDATA = this.cardData.map(cd => {
          return {
            name: cd.name,
            id: cd.id
          }
        })
        if (this.cardData.length) {
          if (!this.initialCall) {
            this.initialCheckbox()
          }
          if (!_.isEqual(cDATA, this.transformedCardData)) {
            this.initialCheckbox()
          }
        }
      }
    },
    reset() {
      this.checkbox = {}
      this.initialCall = false
      this.resetPoint += 1
    },
    active(val) {
      if (val === 'compare_graph') {
        if (this.cardData.length) {
          this.initialCheckbox()
        }
      }
    }
  }
}
</script>

<style scoped>
.toolbar--height {
  height: 50px;
}

.cardData {
  height: 82.2vh;
  overflow-x: hidden;
  overflow-y: auto;
}

/* The checkbox--outer */
.radioBtn--outer {
  display: block;
  position: relative;
  top: 1.875rem;
  padding-left: 2.188rem;
  margin-bottom: 1.25rem;
  cursor: pointer;
  font-size: 1.375rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.radioBtn--outer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.radioBtn--inner {
  position: absolute;
  border: 0.125rem solid darkgray;
  top: 0;
  left: 0;
  height: 1.2rem;
  width: 1.2rem;
  border-radius: 50%;
}

/* When the radio button is checked, add a orange background */
.radioBtn--outer input:checked~.radioBtn--inner {
  border: 0.138rem solid #21E39B;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.radioBtn--inner:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.radioBtn--outer input:checked~.radioBtn--inner:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.radioBtn--outer .radioBtn--inner:after {
  top: 0.2rem;
  left: 0.219rem;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #21E39B;
}

</style>
